import React, { useState } from 'react';
import { useEffect } from 'react';
import CurrencyFormat from 'react-number-format';
import Tooltip from 'react-tooltip-lite';
import { Col, Row } from 'reactstrap';
import Icon from '../../../assets/icons/Icon';
import ContentLoader from '../../../components/ContentLoader';
import { getPortfolioData } from '../src/portfolioApis';
import { useDict } from '../../../contexts/LanguageContext';

const Loader = () => (
    <ContentLoader width="100" height="20" color="loader500">
        <rect width="100%" height="100%" y="0" rx="4" ry="4" />
    </ContentLoader>
);

const PortfolioDashboard = () => {
    const [portfolioData, setPortfolioData] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const dict = useDict();

    const openCapbayPlusModal = () => { };

    const renderWithLoader = (component) => {
        if (isFetching) {
            return <Loader />;
        }
        return component;
    };

    useEffect(() => {
        setIsFetching(true);
        getPortfolioData(handleGetPortfolioData);
        setIsFetching(false);
    }, []);

    const handleGetPortfolioData = (response) => {
        setPortfolioData(response.data.data);
    };

    return (
        <div className="portfolio__summary" data-cy="portfolio__summary">
            {/* <Row>
                <Col xs={6}>
                    {dict.cash}&nbsp;
                    <Tooltip
                        content={dict.cashTooltip}
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon icon="InfoCircle" inline width="11" />
                    </Tooltip>
                </Col>
                <Col
                    xs={6}
                    style={{
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {renderWithLoader(
                        <CurrencyFormat
                            value={portfolioData?.[0].value ?? 0}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row> */}
            <Row>
                <Col xs={6}>
                    {dict.totalInvestment}&nbsp;
                    {/* <Tooltip
                        content={dict.clickToLearnMore}
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon
                            icon="InfoCircle"
                            inline
                            width="11"
                            onClick={openCapbayPlusModal}
                        />
                    </Tooltip> */}
                </Col>
                <Col
                    xs={6}
                    style={{
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {renderWithLoader(
                        <CurrencyFormat
                            value={portfolioData?.invest || '0.00'}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row>
            <Row>
                <Col xs={6}>- {dict.totalWithdrawal}</Col>
                <Col xs={6} style={{ textAlign: 'right' }}>
                    {renderWithLoader(
                        <>
                            (
                            <CurrencyFormat
                                value={portfolioData?.withdrawal || '0.00'}
                                displayType="text"
                                thousandSeparator
                                prefix="฿ "
                            />
                            )
                        </>
                    )}
                </Col>
            </Row>
            <Row style={{ fontWeight: 'bold' }}>
                <Col xs={6}>
                    {dict.balance}&nbsp;
                    {/* <Tooltip
                        content={dict.portfolioTotalTooltip}
                        styles={{ display: 'inline' }}
                        distance={5}
                        arrowSize={8}
                    >
                        <Icon icon="InfoCircle" inline width="11" />
                    </Tooltip> */}
                </Col>
                <Col
                    xs={6}
                    style={{
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {renderWithLoader(
                        <CurrencyFormat
                            value={portfolioData?.balance || '0.00'}
                            displayType="text"
                            thousandSeparator
                            prefix="฿ "
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default PortfolioDashboard;
